var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gfont",class:['g-font', { hover: _vm.hover }, _vm.rows > 1 ? 'rows' : 'row'],attrs:{"title":_vm.isEllipsis ? _vm.cleanHtml : ''},domProps:{"innerHTML":_vm._s(_vm.cleanHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }